import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const profit_breakdown_overall_v3 = (data) =>
  makeRequest("/profit-breakdowns/overall", {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const profit_breakdown_cluster_v3 = (data) =>
  makeRequest(`/profit-breakdowns/cluster/${data.clusterId}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const profit_breakdown_area_v3 = (data) =>
  makeRequest(`/profit-breakdowns/area/${data.area_code}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const profit_breakdown_branch_v3 = (data) => {
  console.log("profit_breakdown_branch_v3", data);
  const urlParams = new URLSearchParams();
  urlParams.append("from", formatDateParam(data.dates.from));
  urlParams.append("to", formatDateParam(data.dates.to));
  return makeRequest(
    `/profit-breakdowns/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
